export default [
    {label: 'Sersh', value: 'Sersh'},
    {label: 'Shamanboo', value: 'Shamanboo'},
    {label: 'Futuris', value: 'Futuris'},
    {label: 'Karkaron', value: 'Karkaron'}
]